import { Icon, Heading, Image, Link, Text } from '@redriverpress/system'

import HitWrapper from './HitWrapper'
import { flashcardPropShape } from '../../constants/propShapes'
import { getFlashcardLink } from '../../utils/hitLinks'
import { resultImageSize } from '../../constants/ui'

export default function FlashcardHit({ hit }) {
  const { category, genre, id, image_url: imageUrl, title } = hit

  const { title: categoryTitle, slug: categorySlug } = category
  const { slug: genreSlug } = genre

  return (
    <Link reset href={getFlashcardLink({ genreSlug, categorySlug, id })}>
      <HitWrapper p={[2, null, 3]} height='100%'>
        <Icon
          icon='bolt'
          position='absolute'
          top={[2, null, 3]}
          left={[2, null, 3]}
          fontSize={[0, null, 1]}
          color='gray900'
        />
        <Image
          display='block'
          size={resultImageSize}
          src={imageUrl}
          alt={`Flashcard image for ${title}`}
          mx='auto'
          mb={2}
        />
        <Heading as='h5' mb={0}>
          {title}
        </Heading>
        <Text fontSize={0}>{categoryTitle}</Text>
      </HitWrapper>
    </Link>
  )
}

FlashcardHit.propTypes = {
  hit: flashcardPropShape.isRequired,
}
